<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Incluir Tópico
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <EducationSystemSelect
            @setEducationSystem="parameters.education_system_id = $event"
          />
          <EducationStageSelect
            :education-system-id="parameters.education_system_id"
            @setEducationStage="parameters.education_stage_id = $event"
          />
          <GradeSelect
            :education-stage-id="parameters.education_stage_id"
            @setGrade="parameters.grade_id = $event"
          />
          <GradeVolumeSelect
            :grade-id="parameters.grade_id"
            @setGradeVolume="parameters.volume_id = $event"
          />
          <GradeSubjectSelect
            :grade-id="parameters.grade_id"
            @setGradeSubject="parameters.subject_id = $event"
          />
          <UnitSelect
            :grade-id="parameters.grade_id"
            :grade-subject-id="parameters.subject_id"
            :grade-volume-id="parameters.volume_id"
            @setUnit="parameters.unit_id = $event"
          />
          <v-select
            v-model="difficulty"
            :items="levels"
            class="px-2"
            item-text="name"
            item-value="id"
            label="Dificuldade"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            :disabled="disabledSave"
            @click="onSubmit()"
          >
            Incluir
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'
import GradeVolumeSelect from '@/components/contents/GradeVolumeSelect.vue'
import GradeSubjectSelect from '@/components/contents/GradeSubjectSelect.vue'
import UnitSelect from '@/components/contents/UnitSelect.vue'
export default {
  components: {
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect,
    GradeVolumeSelect,
    GradeSubjectSelect,
    UnitSelect
  },
  data: () => ({
    difficulty: null,
    parameters: {
      education_system_id: null,
      education_stage_id: null,
      grade_id: null,
      volume_id: null,
      subject_id: null,
      unit_id: null
    },
    levels: [
      {
        name: 'Muito fácil',
        id: 1
      },
      {
        name: 'Fácil',
        id: 2
      },
      {
        name: 'Moderado',
        id: 3
      },
      {
        name: 'Difícil',
        id: 4
      },
      {
        name: 'Muito difícil',
        id: 5
      }
    ]
  }),

  computed: {
    disabledSave () {
      return !this.parameters.unit_id || !this.difficulty
    }
  },

  created () {
  },
  methods: {

    onCancel () {
      this.$emit('resolve', false)
    },

    onSubmit () {
      const save = {
        unit_id: this.parameters.unit_id,
        difficulty: this.difficulty
      }
      this.$emit('resolve', save)
    }
  }
}
</script>
